module.exports = __webpack_public_path__ + "img/id-card.d708146f.png";